/*
 * Yafeapedia
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.61
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AuthorDTO model module.
 * @module model/AuthorDTO
 * @version 1.0.1
 */
export default class AuthorDTO {
  /**
   * Constructs a new <code>AuthorDTO</code>.
   * @alias module:model/AuthorDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AuthorDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AuthorDTO} obj Optional instance to populate.
   * @return {module:model/AuthorDTO} The populated <code>AuthorDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AuthorDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('displayName'))
        obj.displayName = ApiClient.convertToType(data['displayName'], 'String');
      if (data.hasOwnProperty('displayNameEn'))
        obj.displayNameEn = ApiClient.convertToType(data['displayNameEn'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('descriptionEn'))
        obj.descriptionEn = ApiClient.convertToType(data['descriptionEn'], 'String');
      if (data.hasOwnProperty('imgUrl'))
        obj.imgUrl = ApiClient.convertToType(data['imgUrl'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
AuthorDTO.prototype.id = undefined;

/**
 * @member {String} displayName
 */
AuthorDTO.prototype.displayName = undefined;

/**
 * @member {String} displayNameEn
 */
AuthorDTO.prototype.displayNameEn = undefined;

/**
 * @member {String} description
 */
AuthorDTO.prototype.description = undefined;

/**
 * @member {String} descriptionEn
 */
AuthorDTO.prototype.descriptionEn = undefined;

/**
 * @member {String} imgUrl
 */
AuthorDTO.prototype.imgUrl = undefined;

